import React from 'react';
import { eventsListingActions } from '../../../../../../chronusStore/slice/eventsListing';
import CheckBoxFilter from '../../../../../generic/Utils/CheckBoxFilter';
import { useSelector } from '../../../../../../chronusStore/helper';

const Programs = (props) => {
  const selectedValues = useSelector(state => state.eventsListing.filters.programs);
  return(
    <CheckBoxFilter
      dispatchActionFn={ eventsListingActions.updatePrograms }
      selectedValues={ selectedValues }
      newUx={ false }
      { ...props }
    />
  )
}

export default Programs;